<div id="saveAssetListDialog" 
    appDraggable dragTarget="#saveAssetListDialogContent" dragHandle="#saveAssetListDialogHeader"
    class="modal fade in ui-draggable ui-draggable-handle"
    style="width:auto; min-width: 450px; max-width: 100%; min-height: 200px; height: auto; overflow-y: auto; max-height: 100%; display: none;"
    role="dialog"
    tabindex="-1"
    >

    <div role="document" id="saveAssetListDialogContent">
        <div class="modal-content modal-dialog">

            <div class="modal-header" id="saveAssetListDialogHeader">
                <button [class.disabled]="!isUiEnabled" type="button" class="close" aria-label="Close" (click)="onCancelClicked()">
                    <span aria-hidden="true">x</span>
                </button>
                <h4 class="modal-title">
                    <span>Save Asset List?</span>
                </h4>
            </div>

            <div class="modal-body">
                <input type="text" class="form-control" [readonly]="!isUiEnabled" [(ngModel)]="name" />
            </div>

            <div class="modal-footer">
                <button type="button" class="btn btn-default" [class.disabled]="!isUiEnabled" (click)="onCancelClicked()">
                    <i class="fa fa-ban"></i> CANCEL
                </button>
                <button type="button" class="btn btn-primary" [class.disabled]="!isUiEnabled" (click)="onSaveClicked()">
                    <i class="fa fa-refresh"></i> SAVE
                </button>
            </div>

        </div>
    </div>

</div>